/* INOBA: tekst w bieżącym języku sklepu (window.INOBA_T_DANE z layout/theme.liquid),
   z polskim tekstem zapasowym, gdyby klucza zabrakło. */
function INOBA_T(klucz, zapas) {
  var t = window.INOBA_T_DANE;
  return (t && typeof t === 'object' && t[klucz]) || zapas;
}

/* INOBA — wspólny pomocnik animacji.
   Korzystamy z Motion One, które motyw Concept i tak ładuje w vendor.js,
   więc nie dokładamy do sklepu ani jednego zapytania sieciowego.
   Gdy biblioteki nie ma albo użytkownik prosi o ograniczenie ruchu,
   funkcja tylko ustawia stan końcowy i nic nie animuje. */
window.inobaAnimuj = function (el, kadry, opcje, poZakonczeniu) {
  var czas = (opcje && opcje.duration ? opcje.duration : 0.2) * 1000;
  var zrobione = false;

  function stanKoncowy() {
    for (var k in kadry) {
      var v = kadry[k];
      el.style[k] = Array.isArray(v) ? v[v.length - 1] : v;
    }
  }

  function koniec() {
    if (zrobione) return;
    zrobione = true;
    if (poZakonczeniu) poZakonczeniu();
  }

  var bezRuchu = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (bezRuchu || !window.Motion || !window.Motion.animate) {
    stanKoncowy();
    koniec();
    return null;
  }

  var a = window.Motion.animate(el, kadry, opcje || {});
  if (a && a.finished && a.finished.then) a.finished.then(koniec).catch(koniec);

  /* Zabezpieczenie: gdy animacja nie ruszy — karta w tle, oszczędzanie energii,
     przeglądarka bez płynnych klatek — po czasie trwania i tak ustawiamy stan
     końcowy. Bez tego panel mógłby zostać niewidoczny na stałe. */
  setTimeout(function () {
    if (zrobione) return;
    try { if (a && a.stop) a.stop(); else if (a && a.cancel) a.cancel(); } catch (e) {}
    stanKoncowy();
    koniec();
  }, czas + 200);

  return a;
};

/* INOBA — kotwica dla ikon nakładanych na zdjęcie główne.
   Kontener galerii obejmuje też kolumnę miniatur (po przeniesieniu ich
   na prawo), więc ikony przypięte do niego lądowały nad miniaturami.
   Bierzemy kolumnę ze zdjęciem, a gdy jej nie ma — cały kontener. */
window.inobaKolumnaZdjecia = function () {
  var lista = document.querySelector('.product__media-container .product__media-list');
  if (lista) {
    var kol = lista.closest('.product__media-container > div');
    if (kol) return kol;
  }
  return document.querySelector('.product__gallery-container');
};

/* ============================================================
   INOBA — formatowanie kwoty zgodnie z formatem waluty sklepu.
   Format przychodzi z layout/theme.liquid (window.INOBA_FORMAT_CENY),
   bo wcześniej separator tysięcy był zaszyty na sztywno jako kropka
   i po przełączeniu wariantu cena wracała do starego zapisu
   niezależnie od ustawień sklepu.
   ============================================================ */
window.inobaKwota = function (grosze) {
  var format = window.INOBA_FORMAT_CENY || '{{amount_with_comma_separator}} zł';
  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
    var bezGroszy = token.indexOf('no_decimals') !== -1;
    var tysiace = ',';
    var dziesietny = '.';
    if (token.indexOf('comma_separator') !== -1) { tysiace = '.'; dziesietny = ','; }
    else if (token.indexOf('apostrophe_separator') !== -1) { tysiace = "'"; dziesietny = '.'; }
    else if (token.indexOf('space_separator') !== -1) { tysiace = ' '; dziesietny = ','; }
    var kwota = bezGroszy ? String(Math.round(grosze / 100)) : (grosze / 100).toFixed(2);
    var czesci = kwota.split('.');
    var calosc = czesci[0].replace(/\B(?=(\d{3})+(?!\d))/g, tysiace);
    return bezGroszy ? calosc : calosc + dziesietny + czesci[1];
  });
};

/* INOBA – kod autorski: podmiana zdjęcia karty produktu przy najechaniu na próbkę koloru. */
document.addEventListener('DOMContentLoaded', function() {
  const initSwatchHover = () => {
    const swatchItems = document.querySelectorAll('.product-card [data-variant-image]');

    swatchItems.forEach(item => {
      if (item.dataset.hoverInitialized) return;
      item.dataset.hoverInitialized = true;

      item.addEventListener('mouseenter', function() {
        const newImageSrc = this.getAttribute('data-variant-image');
        if (!newImageSrc) return;

        const card = this.closest('.product-card');
        if (!card) return;

        const mainImg = card.querySelector('.product-card__media img');
        if (mainImg) {
          if (!mainImg.getAttribute('data-orig-src')) {
            mainImg.setAttribute('data-orig-src', mainImg.src);
            if (mainImg.srcset) {
              mainImg.setAttribute('data-orig-srcset', mainImg.srcset);
            }
          }

          mainImg.src = newImageSrc;
          if (mainImg.srcset) mainImg.srcset = '';
        }
      });

      item.addEventListener('mouseleave', function() {
        const card = this.closest('.product-card');
        if (!card) return;

        const mainImg = card.querySelector('.product-card__media img');
        if (mainImg && mainImg.getAttribute('data-orig-src')) {
          mainImg.src = mainImg.getAttribute('data-orig-src');
          if (mainImg.getAttribute('data-orig-srcset')) {
            mainImg.srcset = mainImg.getAttribute('data-orig-srcset');
          }
        }
      });
    });
  };

  initSwatchHover();

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    let swatchQueued = false;
    const observer = new MutationObserver(() => {
      if (swatchQueued) return;
      swatchQueued = true;
      requestAnimationFrame(() => { swatchQueued = false; initSwatchHover(); });
    });
    observer.observe(gridContainer, { childList: true, subtree: true });
  }
});

/* ============================================================
   INOBA – lista ulubionych
   Lista trzymana w pamieci przegladarki (localStorage), bez aplikacji
   i bez konta klienta. Znaczniki: snippets/inoba-wishlist-button.liquid,
   sections/inoba-wishlist.liquid, snippets/header-icons.liquid.
   ============================================================ */
(function () {
  var KEY = 'inoba:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* tryb prywatny / brak miejsca */ }
  }

  function syncCounters() {
    var n = read().length;
    document.querySelectorAll('[data-inoba-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncButtons(root) {
    var list = read();
    (root || document).querySelectorAll('[data-inoba-wishlist]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var add = btn.dataset.labelAdd || INOBA_T('ulubione_dodaj', 'Dodaj do ulubionych');
      var remove = btn.dataset.labelRemove || INOBA_T('ulubione_usun', 'Usuń z ulubionych');
      btn.title = on ? remove : add;
      var label = btn.querySelector('[data-inoba-wishlist-label]');
      if (label) label.textContent = on ? remove : add;
    });
  }

  function toggle(handle) {
    if (!handle) return;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    syncButtons();
    syncCounters();
    if (document.querySelector('[data-inoba-wishlist-page]')) renderPage();
  }

  /* Klik na sercu - delegacja, wiec dziala tez na kartach doladowanych AJAX-em */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-inoba-wishlist]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.handle);
  });

  /* Zmiana w innej karcie przegladarki */
  window.addEventListener('inoba:wishlist:refresh', function () {
    syncButtons();
    syncCounters();
  });

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    syncButtons();
    syncCounters();
    if (document.querySelector('[data-inoba-wishlist-page]')) renderPage();
  });

  /* ---------- strona "Ulubione" ---------- */

  var HEART = '<svg class="icon icon-heart icon-md" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 20.25c-.28 0-.55-.1-.77-.28C7.3 16.87 3 13.4 3 9.28 3 6.42 5.2 4.2 7.95 4.2c1.6 0 3.1.77 4.05 2.05.95-1.28 2.45-2.05 4.05-2.05C18.8 4.2 21 6.42 21 9.28c0 4.12-4.3 7.6-8.23 10.69-.22.19-.49.28-.77.28Z"></path></svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function makeMoney(root) {
    var currency = (root && root.dataset.currency) || 'PLN';
    var locale = (root && root.dataset.locale) || 'pl';
    var fmt = null;
    try {
      fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (e) {
      fmt = null;
    }
    return function (cents) {
      var value = (cents || 0) / 100;
      return fmt ? fmt.format(value) : value.toFixed(2) + ' ' + currency;
    };
  }

  function cardHtml(p, money) {
    var imgSep = p.featured_image && p.featured_image.indexOf('?') === -1 ? '?' : '&';
    var img = p.featured_image
      ? '<img src="' + esc(p.featured_image) + imgSep + 'width=600" alt="' + esc(p.title) + '" loading="lazy">'
      : '';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var price = '<span class="price__regular whitespace-nowrap">' + money(p.price) + '</span>' +
      (onSale ? '<span class="price__sale inline-flex items-center h-auto relative">' + money(p.compare_at_price) + '</span>' : '');

    return '' +
      '<div class="inoba-wishlist-card relative flex flex-col" data-inoba-wishlist-card="' + esc(p.handle) + '">' +
        '<div class="inoba-wishlist-card__media relative overflow-hidden">' +
          '<a href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<button type="button" class="inoba-wishlist inoba-wishlist--card is-active" data-inoba-wishlist data-handle="' + esc(p.handle) + '" aria-pressed="true" title="Usun z ulubionych" aria-label="Usun z ulubionych: ' + esc(p.title) + '">' +
            '<span class="inoba-wishlist__icon" aria-hidden="true">' + HEART + '</span>' +
          '</button>' +
        '</div>' +
        '<div class="inoba-wishlist-card__content flex flex-col">' +
          '<p><a class="product-card__title reversed-link text-base-xl font-medium leading-tight" href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>' +
          '<div class="price' + (onSale ? ' price--on-sale' : '') + ' flex flex-wrap items-center gap-2">' + price + '</div>' +
          (p.available ? '' : '<p class="text-opacity text-sm">' + INOBA_T('wyprzedane', 'Wyprzedane') + '</p>') +
        '</div>' +
      '</div>';
  }

  function renderPage() {
    var root = document.querySelector('[data-inoba-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-inoba-wishlist-grid]');
    var empty = root.querySelector('[data-inoba-wishlist-empty]');
    var list = read();

    if (!list.length) {
      if (grid) { grid.innerHTML = ''; grid.hidden = true; }
      if (empty) empty.hidden = false;
      return;
    }

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var money = makeMoney(root);

    Promise.all(list.map(function (handle) {
      return fetch(base + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      /* Produkty usuniete ze sklepu wypadaja z listy, zeby nie zostawaly na zawsze */
      var alive = [];
      var html = '';
      items.forEach(function (p, i) {
        if (!p) return;
        alive.push(list[i]);
        html += cardHtml(p, money);
      });

      if (alive.length !== list.length) { write(alive); syncCounters(); }

      if (!html) {
        if (grid) { grid.innerHTML = ''; grid.hidden = true; }
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      if (grid) { grid.innerHTML = html; grid.hidden = false; }
    });
  }

  function init() {
    syncButtons();
    syncCounters();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Karty doladowywane przy filtrowaniu / stronicowaniu kolekcji */
  var wlGrid = document.getElementById('ProductGridContainer');
  if (wlGrid && window.MutationObserver) {
    var wlQueued = false;
    new MutationObserver(function () {
      if (wlQueued) return;
      wlQueued = true;
      requestAnimationFrame(function () { wlQueued = false; syncButtons(wlGrid); });
    }).observe(wlGrid, { childList: true, subtree: true });
  }
})();

/* ============================================================
   INOBA – ikona ulubionych w naglowku
   Wstawiana skryptem obok koszyka, zeby nie modyfikowac
   snippets/header-icons.liquid (plik motywu, ktory aktualizacje nadpisuja).
   ============================================================ */
(function () {
  var HEART = '<svg class="icon icon-heart icon-md" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 20.25c-.28 0-.55-.1-.77-.28C7.3 16.87 3 13.4 3 9.28 3 6.42 5.2 4.2 7.95 4.2c1.6 0 3.1.77 4.05 2.05.95-1.28 2.45-2.05 4.05-2.05C18.8 4.2 21 6.42 21 9.28c0 4.12-4.3 7.6-8.23 10.69-.22.19-.49.28-.77.28Z"></path></svg>';

  function wishlistUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'pages/ulubione';
  }

  function iconSizeClass() {
    /* Motyw pozwala ustawic rozmiar ikon naglowka (icon-sm/md/lg...).
       Serce przejmuje rozmiar z ikony koszyka, zeby zawsze pasowac. */
    var cartIcon = document.querySelector('.cart-drawer-button svg');
    var cls = cartIcon && cartIcon.getAttribute('class');
    var m = cls && cls.match(/icon-(2?xs|sm|md|lg|xl)/);
    return m ? m[0] : 'icon-md';
  }

  function build() {
    var a = document.createElement('a');
    a.href = wishlistUrl();
    a.className = 'inoba-wishlist-link flex items-center justify-center relative';
    a.setAttribute('data-inoba-wishlist-link', '');
    a.setAttribute('data-no-instant', '');
    a.innerHTML =
      '<span class="sr-only">' + INOBA_T('ulubione', 'Ulubione') + '</span>' +
      HEART.replace('icon-md', iconSizeClass()) +
      '<span class="count absolute top-0 right-0 text-xs" data-inoba-wishlist-count hidden>0</span>';
    return a;
  }

  function inject() {
    var added = 0;
    /* Naglowek moze byc wyrenderowany kilka razy (desktop / szuflada mobilna) */
    document.querySelectorAll('.header__buttons').forEach(function (row) {
      if (row.querySelector('[data-inoba-wishlist-link]')) return;
      var cart = row.querySelector('.cart-drawer-button');
      if (!cart) return;
      row.insertBefore(build(), cart);
      added++;
    });
    /* Zdarzenie tylko po realnym wstawieniu - inaczej obserwator zapetli sie
       na wlasnych zmianach licznika. */
    if (added) window.dispatchEvent(new Event('inoba:wishlist:refresh'));
    return added;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  /* Naglowek bywa przebudowywany (np. sticky header, edytor motywu) */
  var header = document.querySelector('.header-group') || document.body;
  if (header && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; inject(); });
    }).observe(header, { childList: true, subtree: true });
  }
})();

/* ============================================================
   INOBA – plywajacy filtr na kolekcji
   Na samej gorze strony: pelny przycisk na srodku.
   Po odjechaniu od gory: kolko dosuniete do prawej krawedzi.
   ============================================================ */
(function () {
  var pasek = document.querySelector('.facet-sticky');
  if (!pasek) return;

  /* Bez requestAnimationFrame — przelaczenie klasy jest tanie, a rAF bywa
     wstrzymany, gdy karta nie renderuje klatek. */
  function ocen() {
    pasek.classList.toggle('inoba-facet--kolko', window.scrollY > 0);
  }

  ocen();
  window.addEventListener('scroll', ocen, { passive: true });
})();

/* ============================================================
   INOBA – cena na karcie produktu reaguje na zmiane wariantu

   Cena jest rysowana przez autorski widget .inter-price-* osadzony
   w templates/product.json. Widget renderuje sie raz, po stronie
   serwera, dla wariantu obecnego przy wczytaniu strony i sam z siebie
   nie reaguje na przelaczenie wariantu — klient widzial wtedy cene
   innego wariantu niz wybrany. To samo dotyczylo paska sticky.

   Motyw wysyla na formularzu zdarzenie "variant:change" z pelnym
   obiektem wariantu (ceny w groszach), wiec wystarczy przerysowac
   oba miejsca. Oryginalne znaczniki serwera:

     promocja:  <span class="inter-price-compare">  <span class="inter-price-promo">  <span class="inter-savings-badge">
     bez obnizki: <span class="inter-price-standard">
     sticky promocja: .price.price--on-sale > .price__regular + .price__sale
     sticky bez obnizki: .price > .price__regular
   ============================================================ */
(function () {
  var widget = document.querySelector('.inter-price-container');
  var stickyCena = document.querySelector('.product-sticky-form .price');
  var odznakaPromo = document.querySelector('.inoba-product-badges [data-inoba-promo]');
  if (!widget && !stickyCena && !odznakaPromo) return;

  /* Format zgodny z ustawieniami sklepu: 1.729,00 zl */
  function zloty(grosze) {
    return window.inobaKwota(grosze);
  }

  function span(klasa, tekst) {
    var e = document.createElement('span');
    e.className = klasa;
    e.textContent = tekst;
    return e;
  }

  function przerysujWidget(cena, porownawcza) {
    if (!widget) return;
    widget.textContent = '';
    if (porownawcza && porownawcza > cena) {
      widget.appendChild(span('inter-price-compare', zloty(porownawcza)));
      widget.appendChild(span('inter-price-promo', zloty(cena)));
      widget.appendChild(span('inter-savings-badge', 'Oszcz\u0119dzasz ' + zloty(porownawcza - cena)));
    } else {
      widget.appendChild(span('inter-price-standard', zloty(cena)));
    }
    /* Omnibus: najniższa cena z 30 dni przed obniżką = cena regularna wariantu. */
    var omnibus = widget.parentElement && widget.parentElement.querySelector('.inoba-omnibus');
    if (omnibus) {
      var naObnizce = porownawcza && porownawcza > cena;
      omnibus.hidden = !naObnizce;
      var pole = omnibus.querySelector('.inoba-omnibus__cena');
      if (pole) pole.textContent = naObnizce ? zloty(porownawcza) : '';
    }
  }

  function przerysujSticky(cena, porownawcza) {
    if (!stickyCena) return;
    var promocja = porownawcza && porownawcza > cena;
    stickyCena.classList.toggle('price--on-sale', !!promocja);
    stickyCena.textContent = '';
    if (promocja) {
      stickyCena.appendChild(span('sr-only', INOBA_T('cena_sprzedazy', 'Cena sprzeda\u017cy')));
      stickyCena.appendChild(span('price__regular whitespace-nowrap', zloty(cena)));
      stickyCena.appendChild(span('sr-only', INOBA_T('cena_normalna', 'Normalna cena')));
      stickyCena.appendChild(span('price__sale inline-flex items-center h-auto relative', zloty(porownawcza)));
      stickyCena.appendChild(span('inoba-omnibus-mini', INOBA_T('omnibus', 'Najniższa cena w okresie 30 dni przed obniżką:') + ' ' + zloty(porownawcza)));
    } else {
      stickyCena.appendChild(span('price__regular whitespace-nowrap', zloty(cena)));
    }
  }

  /* Odznaka "Promocja" nad nazwa produktu: pokazujemy ja tylko dla wariantow
     z obnizka. Element jest w kodzie strony zawsze, gdy jakikolwiek wariant
     produktu ma cene przed obnizka — snippet inoba-product-badges. */
  function przelaczOdznake(cena, porownawcza) {
    if (!odznakaPromo) return;
    odznakaPromo.hidden = !(porownawcza && porownawcza > cena);
  }

  document.addEventListener('variant:change', function (ev) {
    var w = ev.detail && ev.detail.variant;
    if (!w || typeof w.price !== 'number') return;
    przerysujWidget(w.price, w.compare_at_price);
    przerysujSticky(w.price, w.compare_at_price);
    przelaczOdznake(w.price, w.compare_at_price);
  }, true);
})();

/* ============================================================
   INOBA – probka koloru na telefonie podmienia zdjecie, nie nawiguje

   Probka jest linkiem do wariantu produktu, wiec dotkniecie jej na telefonie
   przenosilo od razu na karte produktu. Na waskich ekranach nie ma najechania
   kursorem, wiec podglad koloru byl nieosiagalny. Teraz dotkniecie podmienia
   zdjecie w kafelku, a na karte produktu prowadzi zdjecie i nazwa.
   Na desktopie zachowanie bez zmian — tam podglad daje najechanie.
   ============================================================ */
(function () {
  var waskie = window.matchMedia('(max-width: 767px)');

  function podmien(link) {
    var poz = link.closest('[data-variant-image]');
    var karta = link.closest('.product-card');
    if (!poz || !karta) return;

    var zdjecie = karta.querySelector('.product-card__media img');
    var nowe = poz.getAttribute('data-variant-image');
    if (!zdjecie || !nowe) return;

    if (!zdjecie.getAttribute('data-orig-src')) {
      zdjecie.setAttribute('data-orig-src', zdjecie.src);
      if (zdjecie.srcset) zdjecie.setAttribute('data-orig-srcset', zdjecie.srcset);
    }
    zdjecie.src = nowe;
    if (zdjecie.srcset) zdjecie.srcset = '';

    /* zaznaczenie aktywnej probki w obrebie kafelka */
    var wszystkie = karta.querySelectorAll('.color-swatch');
    for (var i = 0; i < wszystkie.length; i++) {
      wszystkie[i].classList.toggle('inoba-swatch--wybrana', wszystkie[i] === link);
    }
  }

  document.addEventListener('click', function (ev) {
    if (!waskie.matches) return;
    var link = ev.target.closest('.product-card .color-swatch');
    if (!link) return;
    ev.preventDefault();
    ev.stopPropagation();
    podmien(link);
  }, true);
})();

/* ============================================================
   INOBA – strzalki przy przewijanym pasku cech na karcie produktu

   Pasek cech przewija sie w poziomie, ale nic tego nie sygnalizowalo,
   wiec czesc cech byla praktycznie niewidoczna. Strzalka po prawej
   pojawia sie, gdy jest co pokazac dalej; po lewej — gdy pasek zostal
   juz przewiniety. Same strzalki rysuje CSS.
   ============================================================ */
(function () {
  /* Paski cech sa i na karcie produktu (motyw renderuje je dwa razy — przy
     galerii i w kolumnie opisu, chowajac nieuzywany), i na kazdej miniaturze
     w siatce kolekcji. Obslugujemy wszystkie naraz. */
  var WYBOR = '.product__highlights .product-card__spec, .product-card .product-card__spec';

  /* Bez requestAnimationFrame — przelaczenie dwoch klas jest tanie,
     a rAF bywa wstrzymany, gdy karta nie renderuje klatek. */
  function ocen(ramka) {
    var pas = ramka.querySelector('.product-card__icons');
    if (!pas) return;
    var margines = 4; /* tolerancja na zaokraglenia szerokosci */
    var maxPrzewiniecie = pas.scrollWidth - pas.clientWidth;
    var jestCoPrzewijac = maxPrzewiniecie > margines;
    ramka.classList.toggle('inoba-mozna-w-lewo', jestCoPrzewijac && pas.scrollLeft > margines);
    ramka.classList.toggle('inoba-mozna-w-prawo', jestCoPrzewijac && pas.scrollLeft < maxPrzewiniecie - margines);
  }

  function przelicz() {
    document.querySelectorAll(WYBOR).forEach(ocen);
  }

  /* Nasluch w fazie przechwytywania: zdarzenie scroll nie bableuje, a dzieki
     temu obsluzymy tez miniatury doladowane po zmianie filtrow. */
  document.addEventListener('scroll', function (ev) {
    var pas = ev.target;
    if (!pas || !pas.classList || !pas.classList.contains('product-card__icons')) return;
    var ramka = pas.closest('.product-card__spec');
    if (ramka) ocen(ramka);
  }, true);

  przelicz();
  window.addEventListener('resize', przelicz, { passive: true });

  /* Szerokosc kafelkow zalezy od zaladowanych ikon i czcionek */
  window.addEventListener('load', przelicz);

  /* Siatka kolekcji przeladowuje sie przy filtrowaniu i stronicowaniu */
  var siatka = document.getElementById('ProductGridContainer');
  if (siatka) {
    var zakolejkowane = false;
    new MutationObserver(function () {
      if (zakolejkowane) return;
      zakolejkowane = true;
      setTimeout(function () { zakolejkowane = false; przelicz(); }, 100);
    }).observe(siatka, { childList: true, subtree: true });
  }
})();

/* ============================================================
   INOBA – wybor ilosci przy produktach polecanych w szufladzie koszyka
   Plus i minus obsluzone delegacja, wiec dzialaja tez po przeladowaniu
   zawartosci szuflady po dodaniu produktu.
   ============================================================ */
document.addEventListener('click', function (ev) {
  var minus = ev.target.closest ? ev.target.closest('[data-inoba-qty-minus]') : null;
  var plus = ev.target.closest ? ev.target.closest('[data-inoba-qty-plus]') : null;
  if (!minus && !plus) return;

  var pole = (minus || plus).parentElement.querySelector('.inoba-qty__input');
  if (!pole) return;

  ev.preventDefault();
  var teraz = parseInt(pole.value, 10);
  if (isNaN(teraz)) teraz = 1;
  var min = parseInt(pole.getAttribute('min'), 10) || 1;
  pole.value = plus ? teraz + 1 : Math.max(min, teraz - 1);
});

/* ============================================================
   INOBA – wysokosc naglowka jako zmienna CSS

   Na kolekcji naglowek i pasek filtrow przyklejaly sie do tej samej
   pozycji, wiec filtry znikaly za naglowkiem. Zapisujemy jego realna
   wysokosc, zeby CSS mogl odsunac pasek filtrow dokladnie o tyle.
   ============================================================ */
(function () {
  var sekcja = document.querySelector('.header-section');
  if (!sekcja) return;

  var naglowek = sekcja.querySelector('.header') || sekcja;

  function zmierz() {
    var h = Math.round(naglowek.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--inoba-naglowek', h + 'px');
  }

  zmierz();
  window.addEventListener('load', zmierz);
  window.addEventListener('resize', zmierz, { passive: true });

  if (window.ResizeObserver) new ResizeObserver(zmierz).observe(naglowek);
})();

/* ============================================================
   INOBA – godziny pracy dosuniete do danych kontaktowych w stopce

   Godziny sa osobnym blokiem sekcji, wiec w siatce ladowaly w drugim
   wierszu — a ten zaczyna sie dopiero pod najdluzsza lista linkow.
   Przenosimy je do bloku "Obsluga klienta", zeby stanowily z nim calosc.
   ============================================================ */
(function () {
  var godziny = document.querySelector('.footer .footer__item--inoba_godziny');
  var kontakt = document.querySelector('.footer .footer__contact');
  if (!godziny || !kontakt) return;

  godziny.classList.add('inoba-godziny--przeniesione');
  kontakt.appendChild(godziny);
})();

/* ============================================================
   INOBA – serce „Zapisz" przeniesione na zdjecie produktu
   Zwalnia miejsce w wierszu zakupu, wiec przycisk CTA moze byc szerszy.
   ============================================================ */
(function () {
  var serce = document.querySelector('.buy-buttons .inoba-wishlist--atc');
  var galeria = window.inobaKolumnaZdjecia();
  if (!serce || !galeria) return;

  serce.classList.remove('inoba-wishlist--atc');
  serce.classList.add('inoba-wishlist--na-zdjeciu');
  galeria.appendChild(serce);
})();

/* ============================================================
   INOBA – cena na przycisku zakupu mnozona przez wybrana ilosc

   Motyw pokazuje na przycisku cene jednostkowa i nie reaguje na zmiane
   ilosci. Przeliczamy ja przy kazdej zmianie ilosci i wariantu.
   ============================================================ */
(function () {
  /* Selektory wyliczane przy każdym przeliczeniu, a nie raz przy starcie.
     Wcześniej skrypt kończył działanie, jeśli przy jego uruchomieniu
     przycisku zakupu nie było jeszcze w drzewie — i cena nigdy nie
     reagowała na zmianę ilości. */
  function elCena() {
    return document.querySelector('.buy-buttons .product-form__submit product-buy-price');
  }

  function elPole() {
    return document.querySelector('.buy-buttons .quantity__input');
  }

  function przelicz() {
    var cena = elCena();
    var pole = elPole();
    if (!cena || !pole) return;
    var ile = parseInt(pole.value, 10);
    if (!ile || ile < 1) ile = 1;
    var podstawa = parseInt(cena.getAttribute('data-price'), 10) || 0;
    if (!podstawa) return;
    cena.textContent = window.inobaKwota(podstawa * ile);
  }

  function wSelektorze(cel) {
    return cel && cel.closest && cel.closest('.buy-buttons .quantity');
  }

  /* Delegacja na dokumencie: działa niezależnie od tego, kiedy motyw
     wstawi przycisk zakupu i czy przerysuje go po zmianie wariantu. */
  ['input', 'change'].forEach(function (zdarzenie) {
    document.addEventListener(zdarzenie, function (ev) {
      if (wSelektorze(ev.target)) setTimeout(przelicz, 30);
    }, true);
  });

  /* Plus i minus motywu zmieniają wartość pola bez zdarzenia input. */
  document.addEventListener('click', function (ev) {
    if (wSelektorze(ev.target)) setTimeout(przelicz, 60);
  }, true);

  /* Po zmianie wariantu motyw przepisuje cenę jednostkową. */
  document.addEventListener('variant:change', function () {
    setTimeout(przelicz, 120);
  }, true);

  document.addEventListener('DOMContentLoaded', przelicz);
  przelicz();
})();

/* ============================================================
   UWAGA 16 — czas realizacji zależny od wariantu.

   Motyw pokazuje w bloku tekstowym jedną wartość dla całego produktu.
   Bierzemy wartość z metapola wariantu custom.czas_realizacji (mapa
   wariant -> wartość przychodzi z layout/theme.liquid). Metapole trzyma
   samą liczbę, więc podmieniamy tylko liczbę w tekście bloku — dzięki
   temu klient może dowolnie zmienić brzmienie napisu w edytorze, a
   „dni" i przedrostek zostaną zachowane.

   Gdy metapole wariantu jest puste, wraca wartość domyślna z bloku.
   ============================================================ */
(function () {
  var domyslnyTekst = null;

  function pole() {
    /* Wyłącznie akapit z tekstem. Wcześniej selektor łapał też kontener
       wiersza, a podmiana jego treści kasowała ikonę i klasę zmniejszającą
       czcionkę — wiersz „Wysyłka" wypadał ze stylu pozostałych. */
    var kandydaci = document.querySelectorAll('.product__text .product__text-inner p');
    for (var i = 0; i < kandydaci.length; i++) {
      var t = kandydaci[i].textContent || '';
      /* etykieta wiersza w języku sklepu: PL „Wysyłka:", DE „Versand:", FR „Expédition :",
         NL „Verzending:", EN „Shipping:", CS „Odeslání:", SK „Odoslanie:" */
      if (/(wysy[łl]ka|versand|exp[ée]dition|verzending|shipping|odesl[áa]n[íi]|odoslanie)\s*:/i.test(t)) return kandydaci[i];
    }
    return null;
  }

  function wybranyWariant() {
    var input = document.querySelector('.buy-buttons [name="id"], product-info [name="id"], form [name="id"]');
    if (input && input.value) return String(input.value);
    var zUrl = new URLSearchParams(location.search).get('variant');
    return zUrl ? String(zUrl) : null;
  }

  function przelicz() {
    var el = pole();
    if (!el) return;
    if (domyslnyTekst === null) domyslnyTekst = el.textContent.trim();

    var mapa = window.INOBA_CZAS_REALIZACJI || {};
    var id = wybranyWariant();
    var wartosc = id ? mapa[id] : null;

    if (wartosc === undefined || wartosc === null || String(wartosc).trim() === '') {
      if (el.textContent.trim() !== domyslnyTekst) el.textContent = domyslnyTekst;
      return;
    }

    wartosc = String(wartosc).trim();
    var nowy;
    if (/\d+\s*[-–]\s*\d+|\d+/.test(domyslnyTekst)) {
      nowy = domyslnyTekst.replace(/\d+\s*[-–]\s*\d+|\d+/, wartosc);
    } else {
      nowy = domyslnyTekst + ' ' + wartosc;
    }
    if (el.textContent.trim() !== nowy) el.textContent = nowy;
  }

  document.addEventListener('variant:change', function () { setTimeout(przelicz, 60); }, true);
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.name === 'id') setTimeout(przelicz, 60);
  }, true);
  document.addEventListener('DOMContentLoaded', przelicz);
  przelicz();
})();

/* ============================================================
   UWAGA 22 — ikona udostępniania na zdjęciu produktu.

   Staje obok serca „Zapisz", na komputerze i na telefonie.
   Na telefonach z obsługą systemowego okna udostępniania otwiera je
   od razu — to szybsza i bardziej naturalna droga niż własna lista.
   Na komputerze rozwija panel z kanałami włączonymi w ustawieniach
   motywu plus kopiowaniem adresu.
   ============================================================ */
(function () {
  var dane = window.INOBA_UDOSTEPNIANIE;
  var galeria = window.inobaKolumnaZdjecia();
  if (!dane || !galeria || galeria.querySelector('.inoba-udostepnij')) return;

  var NAZWY = {
    facebook: 'Facebook',
    twitter: 'X (Twitter)',
    pinterest: 'Pinterest',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    email: 'E-mail'
  };

  function adres(kanal) {
    var u = encodeURIComponent(dane.url);
    var t = encodeURIComponent(dane.tytul);
    switch (kanal) {
      case 'facebook': return 'https://www.facebook.com/sharer.php?u=' + u;
      case 'twitter': return 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u;
      case 'pinterest': return 'https://pinterest.com/pin/create/button/?url=' + u + '&media=' + encodeURIComponent(dane.obraz || '') + '&description=' + t;
      case 'telegram': return 'https://telegram.me/share/url?url=' + u + '&text=' + t;
      case 'whatsapp': return 'https://wa.me/?text=' + t + '%20' + u;
      case 'email': return 'mailto:?subject=' + t + '&body=' + u;
      default: return null;
    }
  }

  var przycisk = document.createElement('button');
  przycisk.type = 'button';
  przycisk.className = 'inoba-udostepnij';
  przycisk.setAttribute('aria-label', INOBA_T('udostepnij', 'Udostępnij ten produkt'));
  przycisk.setAttribute('aria-expanded', 'false');
  przycisk.innerHTML =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle>' +
    '<line x1="8.6" y1="10.5" x2="15.4" y2="6.5"></line><line x1="8.6" y1="13.5" x2="15.4" y2="17.5"></line></svg>';

  var panel = document.createElement('div');
  panel.className = 'inoba-udostepnij__panel';
  panel.hidden = true;

  (dane.kanaly || []).forEach(function (kanal) {
    var url = adres(kanal);
    if (!url) return;
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = NAZWY[kanal] || kanal;
    panel.appendChild(a);
  });

  var kopiuj = document.createElement('button');
  kopiuj.type = 'button';
  kopiuj.textContent = INOBA_T('kopiuj_link', 'Kopiuj link');
  kopiuj.addEventListener('click', function () {
    var gotowe = function () {
      kopiuj.textContent = INOBA_T('skopiowano', 'Skopiowano');
      setTimeout(function () { kopiuj.textContent = INOBA_T('kopiuj_link', 'Kopiuj link'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(dane.url).then(gotowe, function () {});
    } else {
      var pom = document.createElement('textarea');
      pom.value = dane.url;
      document.body.appendChild(pom);
      pom.select();
      try { document.execCommand('copy'); gotowe(); } catch (e) {}
      document.body.removeChild(pom);
    }
  });
  panel.appendChild(kopiuj);

  function zwin() {
    panel.hidden = true;
    przycisk.setAttribute('aria-expanded', 'false');
  }

  przycisk.addEventListener('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    if (navigator.share) {
      navigator.share({ title: dane.tytul, url: dane.url }).catch(function () {});
      return;
    }
    var otwarty = panel.hidden === false;
    panel.hidden = otwarty;
    przycisk.setAttribute('aria-expanded', otwarty ? 'false' : 'true');
  });

  document.addEventListener('click', function (ev) {
    if (!panel.hidden && !panel.contains(ev.target) && ev.target !== przycisk) zwin();
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') zwin();
  });

  var oprawa = document.createElement('div');
  oprawa.className = 'inoba-udostepnij-oprawa';
  oprawa.appendChild(przycisk);
  oprawa.appendChild(panel);
  galeria.appendChild(oprawa);
})();

/* ============================================================
   Etykieta „Raty:" przy kalkulatorze ratalnym.

   Budujemy ją z tych samych elementów co pozostałe wiersze ramki
   korzyści — ikona 20 px o grubości kreski 1 plus akapit w klasie
   text-sm — żeby font, odstęp i wyrównanie zgadzały się co do piksela
   zamiast być odtwarzane osobnymi regułami stylów.
   ============================================================ */
(function () {
  var blok = document.querySelector('.product__info .shopify-app-block[id*="p24"]');
  if (!blok || blok.querySelector('.inoba-raty-etykieta')) return;

  var wzor = document.querySelector('.product__text .product__text-inner');
  var klasaAkapitu = 'rte text-sm leading-tight';
  if (wzor) {
    var p = wzor.querySelector('p');
    if (p && p.className) klasaAkapitu = p.className;
  }

  var etykieta = document.createElement('span');
  etykieta.className = 'inoba-raty-etykieta flex items-center gap-2d5';
  etykieta.innerHTML =
    '<svg class="icon icon-custom inline-block stroke-1" width="20" height="20" viewBox="0 0 24 24" ' +
    'stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" role="presentation">' +
    '<rect x="2.5" y="5" width="19" height="14" rx="2.5"></rect>' +
    '<line x1="2.5" y1="9.5" x2="21.5" y2="9.5"></line>' +
    '<line x1="6" y1="14.5" x2="10" y2="14.5"></line>' +
    '</svg>' +
    '<p class="' + klasaAkapitu + '">Raty:</p>';

  blok.insertBefore(etykieta, blok.firstChild);
})();
/* ============================================================
   Podgląd tapicerki po najechaniu na próbkę koloru (komputer).

   Panel wisi przy <body> i jest pozycjonowany na sztywno względem okna,
   a nasłuch siedzi na dokumencie. Wcześniej jedno i drugie było wpięte
   w rząd próbek — a motyw przerysowuje go po każdej zmianie wariantu,
   więc podgląd przestawał działać po pierwszym kliknięciu.

   Panel staje NAD rzędem próbek i jest dosunięty w prawo poza kolumnę
   z opisem, żeby nie zasłaniał przycisku zakupu poniżej.
   ============================================================ */
(function () {
  var dane = window.INOBA_TAPICERKA;
  if (!dane || !dane.podglad) return;

  function naKomputerze() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  var SZEROKOSC = 180;
  var SZEROKOSC_TELEFON = 130;
  var ODSTEP = 8;
  var WYSUNIECIE = 24;
  var panel = null;
  var animacjaUkrycia = null;

  function zbudujPanel() {
    if (panel && document.body.contains(panel)) return panel;
    panel = document.createElement('div');
    panel.className = 'inoba-tapicerka';
    panel.hidden = true;
    panel.innerHTML = '<img alt="" loading="lazy"><span class="inoba-tapicerka__kolor"></span><span class="inoba-tapicerka__nazwa"></span>';
    document.body.appendChild(panel);
    return panel;
  }

  function adresProbki(el) {
    var tlo = getComputedStyle(el).backgroundImage || '';
    var m = tlo.match(/url\(["']?(.*?)["']?\)/);
    if (!m) return null;
    /* Ten sam plik w większej szerokości — parametr width obsługuje CDN Shopify. */
    return m[1].replace(/([?&]width=)\d+/, '$1600');
  }

  function nazwaProbki(el) {
    var opis = (el.getAttribute('data-value') || el.textContent || '').trim();
    /* Motyw dubluje nazwę w treści etykiety (raz widocznie, raz dla czytników). */
    var polowa = opis.slice(0, Math.ceil(opis.length / 2));
    if (opis === polowa + polowa) opis = polowa;
    return opis;
  }

  function ustawPozycje(probka) {
    var rzad = probka.closest('.swatches') || probka;
    var kolumna = document.querySelector('product-info.product__info') || document.querySelector('.product__info');
    var r = rzad.getBoundingClientRect();
    var k = kolumna ? kolumna.getBoundingClientRect() : r;

    var szerokosc = panel.offsetWidth || (naKomputerze() ? SZEROKOSC : SZEROKOSC_TELEFON);
    var wysokosc = panel.offsetHeight || szerokosc + 40;
    var lewa;

    if (naKomputerze()) {
      /* Wolne miejsce ciągnie się od prawej krawędzi ostatniej próbki do
         prawej krawędzi kolumny z opisem. Przy kilku próbkach pasmo jest
         szerokie, więc panel staje na jego środku zamiast przy samej
         krawędzi ekranu; przy pełnym rzędzie próbek wraca pod prawą
         krawędź, bo inaczej nie zmieściłby się obok. */
      /* Kafelek z filmem stoi na końcu tego samego rzędu — liczy się
         tak samo jak próbka, żeby panel nigdy na niego nie wszedł. */
      var kafle = rzad.querySelectorAll('.color-swatch, .inoba-wideo-kafel');
      var prawaProbek = r.left;
      for (var i = 0; i < kafle.length; i++) {
        prawaProbek = Math.max(prawaProbek, kafle[i].getBoundingClientRect().right);
      }
      var pasmoOd = prawaProbek + ODSTEP;
      var pasmoDo = Math.min(k.right + WYSUNIECIE, window.innerWidth - ODSTEP);
      if (pasmoDo - pasmoOd >= szerokosc) {
        lewa = pasmoOd + (pasmoDo - pasmoOd - szerokosc) / 2;
      } else {
        lewa = Math.max(ODSTEP, pasmoDo - szerokosc);
      }
    } else {
      /* Na telefonie panel dosunięty do prawej krawędzi kolumny. Mniejszy
         i przy krawędzi nie zasłania ani rzędu wariantów, ani kafelka
         z filmem, który stoi na końcu tego rzędu. */
      lewa = k.right - szerokosc;
      lewa = Math.max(ODSTEP, Math.min(lewa, window.innerWidth - szerokosc - ODSTEP));
    }
    /* Na komputerze panel wyśrodkowany w pionie na rzędzie próbek — nie
       zasłania wtedy nazwy produktu ani przycisku zakupu. Na telefonie
       staje nad rzędem, bo obok próbek nie ma już wolnego miejsca. */
    /* Na telefonie panel siada tuż nad rzędem próbek — 2 px zamiast 8 px,
       żeby zszedł możliwie nisko, ale nie wchodził na warianty. */
    var gora = naKomputerze()
      ? r.top + (r.height / 2) - (wysokosc / 2)
      : r.top - wysokosc - 2;
    if (!naKomputerze() && gora < ODSTEP) gora = r.bottom + ODSTEP;

    var cta = document.querySelector('.buy-buttons');
    if (cta) {
      var c = cta.getBoundingClientRect();
      if (gora + wysokosc > c.top - ODSTEP) gora = c.top - ODSTEP - wysokosc;
    }
    if (gora < ODSTEP) gora = ODSTEP;

    panel.style.left = Math.round(lewa) + 'px';
    panel.style.top = Math.round(gora) + 'px';
  }

  function pokaz(probka) {
    zbudujPanel();
    var url = adresProbki(probka);
    var obraz = panel.querySelector('img');
    var kolor = panel.querySelector('.inoba-tapicerka__kolor');

    /* Część kolorów nie ma wgranego zdjęcia tkaniny — wtedy pokazujemy
       powiększenie tego, co widać na próbce, czyli samą płaszczyznę koloru. */
    if (url) {
      obraz.src = url;
      obraz.alt = nazwaProbki(probka);
      obraz.hidden = false;
      kolor.hidden = true;
    } else {
      obraz.hidden = true;
      kolor.hidden = false;
      var tlo = getComputedStyle(probka).backgroundColor;
      kolor.style.background = (tlo && tlo !== 'rgba(0, 0, 0, 0)') ? tlo : 'rgb(var(--color-text) / 0.08)';
    }
    panel.querySelector('.inoba-tapicerka__nazwa').textContent = nazwaProbki(probka);
    if (animacjaUkrycia) {
      try { if (animacjaUkrycia.animacja && animacjaUkrycia.animacja.stop) animacjaUkrycia.animacja.stop(); } catch (e) {}
      animacjaUkrycia = null;
    }
    panel.hidden = false;
    ustawPozycje(probka);
    panel.style.opacity = '';
    panel.style.transform = '';
    window.inobaAnimuj(panel, { opacity: [0, 1], transform: ['translateY(12px) scale(0.94)', 'none'] },
      { duration: 0.45, easing: [0.16, 1, 0.3, 1] });
  }

  function ukryj() {
    if (!panel || panel.hidden) return;
    var znacznik = {};
    animacjaUkrycia = znacznik;
    znacznik.animacja = window.inobaAnimuj(panel,
      { opacity: [1, 0], transform: ['none', 'translateY(12px) scale(0.94)'] },
      { duration: 0.28, easing: 'ease-in' },
      function () {
        if (animacjaUkrycia === znacznik) { panel.hidden = true; animacjaUkrycia = null; }
      });
  }

  document.addEventListener('mouseover', function (ev) {
    if (!naKomputerze()) return;
    var probka = ev.target.closest && ev.target.closest('.variant-picker .color-swatch');
    if (probka) pokaz(probka);
  }, true);

  /* Na telefonie nie ma najechania kursorem — podgląd otwiera dotknięcie
     próbki. Wybór wariantu działa przy tym normalnie, bo nie blokujemy
     zdarzenia; panel nie przechwytuje dotknięć (pointer-events: none). */
  document.addEventListener('click', function (ev) {
    if (naKomputerze()) return;
    if (!ev.target.closest) return;
    var probka = ev.target.closest('.variant-picker .color-swatch');
    if (probka) { pokaz(probka); return; }
    /* Kliknięcie etykiety przekazuje drugie zdarzenie do powiązanego pola
       wyboru, które leży obok próbki. Bez tego wyjątku panel zamykałby się
       natychmiast po otwarciu. */
    if (ev.target.closest('.variant-picker')) return;
    ukryj();
  }, true);

  document.addEventListener('mouseout', function (ev) {
    if (!naKomputerze()) return;
    var probka = ev.target.closest && ev.target.closest('.variant-picker .color-swatch');
    if (!probka) return;
    var doKogo = ev.relatedTarget;
    if (doKogo && doKogo.closest && doKogo.closest('.variant-picker .color-swatch')) return;
    ukryj();
  }, true);

  /* Film przykrywa całą kolumnę z opisem, więc podgląd tapicerki musi
     wtedy zejść z drogi. Udostępniamy zamykanie na zewnątrz, żeby kafelek
     z filmem mógł je wywołać. */
  window.inobaUkryjPodglad = ukryj;

  window.addEventListener('scroll', ukryj, { passive: true });
  window.addEventListener('resize', ukryj);
})();
/* ============================================================
   Film przy wyborze wariantu.

   Kafelek dostawiony na końcu rzędu próbek. Na komputerze film
   wysuwa się szufladą z prawej krawędzi ekranu, na pełną jego
   wysokość i w całości widoczny. Na telefonie przykrywa kolumnę
   z informacjami o produkcie. Zamknięcie przyciskiem, klawiszem
   Escape albo kliknięciem w tło.
   ============================================================ */
(function () {
  var dane = window.INOBA_TAPICERKA;
  if (!dane || !dane.wideo) return;

  var kolumna = document.querySelector('product-info.product__info') || document.querySelector('.product__info');
  if (!kolumna) return;

  var nakladka = null;   /* nakładka na kolumnie z opisem — telefon */
  var szuflada = null;   /* szuflada z prawej krawędzi ekranu — komputer */
  var przewijanie = '';

  /* Motyw przerysowuje rząd próbek po każdej zmianie wariantu i kasuje
     wtedy nasz kafelek — dlatego dostawiamy go ponownie po każdej zmianie
     i pilnujemy tego obserwatorem zmian w kolumnie z opisem. */
  function dodajKafel() {
    var rzad = document.querySelector('.variant-picker .swatches');
    if (!rzad || rzad.querySelector('.inoba-wideo-kafel')) return;

    var kafel = document.createElement('li');
    kafel.className = 'inoba-wideo-kafel';
    kafel.innerHTML =
      '<button type="button" aria-label="' + INOBA_T('film_odtworz', 'Odtwórz film o produkcie') + '"' +
      (dane.plakat ? ' style="background-image:url(' + dane.plakat + ')"' : '') + '>' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>' +
      '</button>' +
      '<span class="tooltip opacity-0 pointer-events-none text-xs rounded-full z-10">' + INOBA_T('film_tkaniny', 'Odtwórz podgląd wyglądu tkanin') + '</span>';
    rzad.appendChild(kafel);
    kafel.querySelector('button').addEventListener('click', otworz);
  }

  function naKomputerze() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function zamknij() {
    if (szuflada) { zamknijSzuflade(); return; }
    if (!nakladka) return;
    var doZamkniecia = nakladka;
    nakladka = null;
    var film = doZamkniecia.querySelector('video');
    if (film) film.pause();
    document.removeEventListener('keydown', naEscape, true);
    window.inobaAnimuj(doZamkniecia, { opacity: [1, 0], transform: ['none', 'scale(0.92)'] },
      { duration: 0.32, easing: 'ease-in' },
      function () { doZamkniecia.remove(); });
  }

  function zamknijSzuflade() {
    var doZamkniecia = szuflada;
    szuflada = null;
    var film = doZamkniecia.querySelector('video');
    if (film) film.pause();
    document.removeEventListener('keydown', naEscape, true);
    odblokujPrzewijanie();
    window.inobaAnimuj(doZamkniecia.querySelector('.inoba-wideo-szuflada__tlo'),
      { opacity: [1, 0] }, { duration: 0.3, easing: 'ease-in' });
    window.inobaAnimuj(doZamkniecia.querySelector('.inoba-wideo-szuflada__panel'),
      { transform: ['none', 'translateX(100%)'] }, { duration: 0.4, easing: [0.4, 0, 1, 1] },
      function () { doZamkniecia.remove(); });
  }

  /* Strona pod szufladą nie przewija się razem z nią. Motyw trzyma
     scrollbar-gutter: stable, więc miejsce po pasku przewijania jest
     zarezerwowane na stałe i blokada niczego nie przesuwa. */
  function zablokujPrzewijanie() {
    przewijanie = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
  }

  function odblokujPrzewijanie() {
    document.documentElement.style.overflow = przewijanie;
  }

  function naEscape(ev) {
    if (ev.key === 'Escape') zamknij();
  }

  /* Komputer: film wysuwa się z prawej krawędzi ekranu na całą jego
     wysokość. Szerokość szuflady bierze się z proporcji filmu, więc
     kadr mieści się w całości bez przycinania. */
  function otworzSzuflade() {
    szuflada = document.createElement('div');
    szuflada.className = 'inoba-wideo-szuflada';
    szuflada.setAttribute('role', 'dialog');
    szuflada.setAttribute('aria-modal', 'true');
    szuflada.setAttribute('aria-label', INOBA_T('film_tytul', 'Film o produkcie'));
    szuflada.innerHTML =
      '<div class="inoba-wideo-szuflada__tlo"></div>' +
      '<div class="inoba-wideo-szuflada__panel">' +
      '<button type="button" class="inoba-wideo-zamknij" aria-label="Zamknij film">&times;</button>' +
      '<video controls autoplay playsinline preload="metadata"' +
      (dane.plakat ? ' poster="' + dane.plakat + '"' : '') +
      '><source src="' + dane.wideo + '"></video>' +
      '</div>';
    document.body.appendChild(szuflada);

    var panel = szuflada.querySelector('.inoba-wideo-szuflada__panel');
    var film = szuflada.querySelector('video');
    /* Rzeczywiste proporcje znamy dopiero po wczytaniu metadanych;
       do tego czasu obowiązuje kadr pionowy z arkusza stylów. */
    function ustawProporcje() {
      if (film.videoWidth && film.videoHeight) {
        panel.style.setProperty('--inoba-wideo-proporcje', film.videoWidth + ' / ' + film.videoHeight);
      }
    }
    film.addEventListener('loadedmetadata', ustawProporcje);
    ustawProporcje();

    szuflada.querySelector('.inoba-wideo-zamknij').addEventListener('click', zamknij);
    szuflada.querySelector('.inoba-wideo-szuflada__tlo').addEventListener('click', zamknij);
    document.addEventListener('keydown', naEscape, true);
    zablokujPrzewijanie();

    window.inobaAnimuj(szuflada.querySelector('.inoba-wideo-szuflada__tlo'),
      { opacity: [0, 1] }, { duration: 0.4, easing: 'ease-out' });
    window.inobaAnimuj(panel, { transform: ['translateX(100%)', 'none'] },
      { duration: 0.55, easing: [0.16, 1, 0.3, 1] });
  }

  function otworz() {
    if (szuflada || nakladka) { zamknij(); return; }
    /* Podgląd tapicerki zamykamy płynnie, zanim film wejdzie na wierzch. */
    if (window.inobaUkryjPodglad) window.inobaUkryjPodglad();
    if (naKomputerze()) { otworzSzuflade(); return; }
    nakladka = document.createElement('div');
    nakladka.className = 'inoba-wideo-nakladka';
    nakladka.innerHTML =
      '<button type="button" class="inoba-wideo-zamknij" aria-label="Zamknij film">&times;</button>' +
      '<video controls autoplay playsinline preload="metadata"' +
      (dane.plakat ? ' poster="' + dane.plakat + '"' : '') +
      '><source src="' + dane.wideo + '"></video>';
    kolumna.appendChild(nakladka);
    nakladka.querySelector('.inoba-wideo-zamknij').addEventListener('click', zamknij);
    nakladka.addEventListener('click', function (ev) {
      if (ev.target === nakladka) zamknij();
    });
    document.addEventListener('keydown', naEscape, true);
    window.inobaAnimuj(nakladka, { opacity: [0, 1], transform: ['scale(0.92)', 'none'] },
      { duration: 0.55, easing: [0.16, 1, 0.3, 1] });
  }

  dodajKafel();
  document.addEventListener('variant:change', function () { setTimeout(dodajKafel, 60); }, true);
  new MutationObserver(function () { dodajKafel(); }).observe(kolumna, { childList: true, subtree: true });
})();

/* ============================================================
   Przełącznik liczby produktów w rzędzie — strona kolekcji.

   Na telefonie 1 albo 2 kolumny, na komputerze 4, 5 albo 6.
   Wybór zapamiętujemy osobno dla każdego z tych dwóch widoków,
   żeby zmiana na telefonie nie przestawiała układu na komputerze.

   Siatkę motyw przerysowuje po każdym filtrowaniu i sortowaniu,
   więc ustawienie nakładamy ponownie przy każdej zmianie w liście.
   ============================================================ */
(function () {
  var pasek = document.querySelector('.collection .facet-topbar') || document.querySelector('.facet-topbar');
  if (!pasek) return;
  if (!document.querySelector('.collection .card-grid')) return;

  var WIDOKI = {
    mobile: { klucz: 'inoba-kolumny-mobile', opcje: [1, 2], domyslna: 2, zmienna: '--inoba-kolumny-mobile' },
    desktop: { klucz: 'inoba-kolumny-desktop', opcje: [4, 5, 6], domyslna: 4, zmienna: '--inoba-kolumny-desktop' }
  };

  function odczytaj(nazwa) {
    var w = WIDOKI[nazwa];
    var zapis;
    try { zapis = localStorage.getItem(w.klucz); } catch (e) { zapis = null; }
    var n = parseInt(zapis, 10);
    return w.opcje.indexOf(n) >= 0 ? n : w.domyslna;
  }

  function zapisz(nazwa, n) {
    try { localStorage.setItem(WIDOKI[nazwa].klucz, String(n)); } catch (e) {}
  }

  function nalozNaSiatke() {
    var siatki = document.querySelectorAll('.collection .card-grid');
    for (var i = 0; i < siatki.length; i++) {
      var s = siatki[i];
      s.setAttribute('data-inoba-kolumny', '');
      /* Osobno w atrybucie, bo przy jednej kolumnie trzeba jeszcze ujarzmić
         karty promocyjne rozpięte na dwie (grid-column: span 2). */
      s.setAttribute('data-inoba-mobile', odczytaj('mobile'));
      s.style.setProperty(WIDOKI.mobile.zmienna, odczytaj('mobile'));
      s.style.setProperty(WIDOKI.desktop.zmienna, odczytaj('desktop'));
    }
  }

  function zbudujIkone(n) {
    var kropki = '';
    /* Dwa rzędy kropek — tyle w rzędzie, ile kolumn daje przycisk. */
    for (var i = 0; i < n * 2; i++) kropki += '<i></i>';
    return '<span class="inoba-widok__ikona" style="--inoba-ikona-kolumny:' + n + '">' + kropki + '</span>';
  }

  var pudelko = document.createElement('div');
  pudelko.className = 'inoba-widok';
  pudelko.setAttribute('role', 'group');
  pudelko.setAttribute('aria-label', INOBA_T('siatka_liczba', 'Liczba produktów w rzędzie'));

  Object.keys(WIDOKI).forEach(function (nazwa) {
    WIDOKI[nazwa].opcje.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'inoba-widok__przycisk';
      b.setAttribute('data-widok', nazwa);
      b.setAttribute('data-kolumny', String(n));
      b.setAttribute('aria-label', n + ' ' + INOBA_T('siatka_w_rzedzie', 'w rzędzie'));
      b.title = n + ' ' + INOBA_T('siatka_w_rzedzie', 'w rzędzie');
      b.innerHTML = zbudujIkone(n);
      b.addEventListener('click', function () {
        zapisz(nazwa, n);
        odswiezPrzyciski();
        nalozNaSiatke();
      });
      pudelko.appendChild(b);
    });
  });

  function odswiezPrzyciski() {
    var wybrane = { mobile: odczytaj('mobile'), desktop: odczytaj('desktop') };
    var b = pudelko.querySelectorAll('.inoba-widok__przycisk');
    for (var i = 0; i < b.length; i++) {
      var nazwa = b[i].getAttribute('data-widok');
      var n = parseInt(b[i].getAttribute('data-kolumny'), 10);
      b[i].setAttribute('aria-pressed', wybrane[nazwa] === n ? 'true' : 'false');
    }
  }

  pasek.appendChild(pudelko);
  odswiezPrzyciski();
  nalozNaSiatke();

  var lista = document.querySelector('.collection') || document.body;
  new MutationObserver(function () { nalozNaSiatke(); }).observe(lista, { childList: true, subtree: true });
})();


/* ============================================================
   Listing kategorii (telefon): przełącznik kolumn przyklejony dokładnie
   pod dolną krawędzią nagłówka. Nagłówek zmienia wysokość i położenie
   przy przewijaniu (pasek ogłoszeń odjeżdża, nagłówek się zmniejsza albo
   chowa), więc stała wartość zostawiała szczelinę. Liczymy ją na bieżąco.
   ============================================================ */
(function () {
  if (!document.querySelector('.collection__topbar .inoba-widok')) return;
  var naglowek = document.querySelector('.header-section');
  var root = document.documentElement;
  /* Motyw chowa nagłówek, przesuwając wewnętrzny .header (sekcja stoi w miejscu),
     więc mierzymy właśnie jego. */
  var ruchomy = naglowek ? (naglowek.querySelector(".header") || naglowek) : null;
  function ustaw() {
    var dol = ruchomy ? ruchomy.getBoundingClientRect().bottom : 0;
    root.style.setProperty('--inoba-pod-naglowkiem', Math.max(0, Math.round(dol)) + 'px');
  }
  ustaw();
  window.addEventListener('scroll', ustaw, { passive: true });
  window.addEventListener('resize', ustaw);
  if (naglowek) naglowek.addEventListener('transitionend', ustaw);
  /* Podczas animacji chowania/pokazywania nie ma zdarzeń scroll — śledzimy
     położenie klatka po klatce przez czas animacji. */
  if (naglowek && window.MutationObserver) {
    var koniec = 0;
    function sledz() { ustaw(); if (performance.now() < koniec) requestAnimationFrame(sledz); }
    new MutationObserver(function () {
      var bylo = performance.now() < koniec;
      koniec = performance.now() + 700;
      if (!bylo) requestAnimationFrame(sledz);
    }).observe(naglowek, { attributes: true, attributeFilter: ["class"] });
  }
})();

/* ============================================================
   BANERY W SIATCE KOLEKCJI — chowanie banerów poza produktami.
   Baner ma na sztywno przypisany rząd (2., 4., 6. …). Jeśli kolekcja
   ma mniej produktów, niż trzeba do tego rzędu, baner stałby samotnie
   pod listą — wtedy go chowamy. Sprawdzamy ponownie po zmianie liczby
   kolumn, dociągnięciu produktów i filtrowaniu.
   ============================================================ */
(function () {
  if (!document.body.classList.contains('template-collection')) return;
  var czas = null;

  function sprawdz() {
    document.querySelectorAll('.card-grid').forEach(function (siatka) {
      var banery = siatka.querySelectorAll(':scope > .inoba-baner');
      if (!banery.length) return;
      banery.forEach(function (b) { b.style.display = ''; });
      var dolProduktow = 0;
      siatka.querySelectorAll(':scope > .card:not(.product-card--promo)').forEach(function (k) {
        var r = k.getBoundingClientRect();
        if (r.height && r.bottom > dolProduktow) dolProduktow = r.bottom;
      });
      banery.forEach(function (b) {
        if (b.getBoundingClientRect().top >= dolProduktow - 1) b.style.display = 'none';
      });
    });
  }

  function pozniej() {
    clearTimeout(czas);
    czas = setTimeout(sprawdz, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sprawdz);
  else sprawdz();
  window.addEventListener('load', sprawdz);
  window.addEventListener('resize', pozniej);
  new MutationObserver(function (zmiany) {
    for (var i = 0; i < zmiany.length; i++) {
      var z = zmiany[i];
      if (z.target.closest && z.target.closest('.inoba-baner')) continue;
      pozniej();
      return;
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-inoba-kolumny', 'data-inoba-mobile'] });

  /* Zmiana liczby kolumn zmienia szerokość kart, a więc i wysokość siatki. */
  if (window.ResizeObserver) {
    var obserwowane = new WeakSet();
    var ro = new ResizeObserver(pozniej);
    function podepnij() {
      document.querySelectorAll('.card-grid').forEach(function (s) {
        if (!obserwowane.has(s) && s.querySelector(':scope > .inoba-baner')) { obserwowane.add(s); ro.observe(s); }
      });
    }
    podepnij();
    document.addEventListener('DOMContentLoaded', podepnij);
    new MutationObserver(podepnij).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ============================================================
   PRODUKT ZA 0 ZŁ — blokada dodania do koszyka.
   1. Karta produktu: przy zmianie wariantu na taki z ceną 0 zł przycisk
      „Dodaj do koszyka" (także w przyklejonym pasku) się wyłącza,
      a „Kup teraz" znika. Wariant z ceną wraca wszystko do normy.
   2. Każde dodanie do koszyka przez /cart/add (karta produktu, pasek,
      szybkie dodawanie, polecane w koszyku): wariant z listy 0 zł jest
      odrzucany od razu, a gdyby jakiś przeszedł (cena nieznana skryptowi),
      odpowiedź sklepu jest sprawdzana i pozycja za 0 zł wraca z koszyka.
   ============================================================ */
(function () {
  var KOMUNIKAT = INOBA_T('cena_zero_komunikat', 'Tego produktu nie można jeszcze kupić — nie ma ustalonej ceny.');
  var ETYKIETA = INOBA_T('cena_zero_przycisk', 'Produkt chwilowo niedostępny');

  function zbiorZero() {
    return (window.inobaCenyZero || []).map(String);
  }

  function ustawFormularz(form, zero) {
    if (!form) return;
    form.classList.toggle('inoba-cena-zero', zero);
    var przyciski = document.querySelectorAll('button[name="add"][form="' + form.id + '"], #' + CSS.escape(form.id) + ' button[name="add"]');
    przyciski.forEach(function (b) {
      var napis = b.querySelector('.btn-text > span') || b.querySelector('.btn-text');
      if (zero) {
        if (napis && !b.dataset.inobaEtykieta) b.dataset.inobaEtykieta = napis.textContent;
        if (napis) napis.textContent = ETYKIETA;
        b.setAttribute('data-inoba-cena-zero', '');
        b.disabled = true;
      } else if (b.hasAttribute('data-inoba-cena-zero')) {
        if (napis && b.dataset.inobaEtykieta) napis.textContent = b.dataset.inobaEtykieta;
        delete b.dataset.inobaEtykieta;
        b.removeAttribute('data-inoba-cena-zero');
        b.disabled = false;
      }
    });
  }

  document.addEventListener('variant:change', function (ev) {
    var w = ev.detail && ev.detail.variant;
    if (!w || typeof w.price !== 'number') return;
    var form = (ev.target && ev.target.closest && ev.target.closest('form[is="product-form"]')) || document.querySelector('form[is="product-form"]');
    /* Motyw sam przestawia przycisk po zmianie wariantu — działamy po nim. */
    setTimeout(function () { ustawFormularz(form, w.price === 0); }, 0);
  }, true);

  function idZZapytania(body) {
    var ids = [];
    try {
      if (body instanceof FormData) {
        body.getAll('id').forEach(function (v) { ids.push(String(v)); });
        body.forEach(function (v, k) { if (/^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); });
      } else if (typeof body === 'string' && body) {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.id) ids.push(String(j.id));
          (j.items || []).forEach(function (i) { if (i.id) ids.push(String(i.id)); });
        } else {
          new URLSearchParams(body).forEach(function (v, k) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); });
        }
      }
    } catch (e) {}
    return ids;
  }

  function odmowa() {
    return new Response(JSON.stringify({ status: 422, message: KOMUNIKAT, description: KOMUNIKAT }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  var oryginalny = window.fetch;
  if (!oryginalny) return;
  window.fetch = function (zasob, opcje) {
    var url = typeof zasob === 'string' ? zasob : (zasob && zasob.url) || '';
    var metoda = ((opcje && opcje.method) || (zasob && zasob.method) || 'GET').toUpperCase();
    if (metoda !== 'POST' || !/\/cart\/add/.test(url)) return oryginalny.apply(this, arguments);

    var zero = zbiorZero();
    var ids = idZZapytania(opcje && opcje.body);
    if (ids.some(function (id) { return zero.indexOf(id) !== -1; })) return Promise.resolve(odmowa());

    return oryginalny.apply(this, arguments).then(function (odp) {
      if (!odp.ok) return odp;
      return odp.clone().json().then(function (dane) {
        var pozycje = dane && (dane.items || (dane.key ? [dane] : []));
        var darmowe = (pozycje || []).filter(function (p) {
          return p && p.key && (p.final_price === 0 || p.price === 0) && p.gift_card !== true;
        });
        if (!darmowe.length) return odp;
        var zmiany = {};
        darmowe.forEach(function (p) { zmiany[p.key] = 0; });
        return oryginalny.call(window, (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: zmiany })
        }).then(function () { return odmowa(); }, function () { return odmowa(); });
      }, function () { return odp; });
    });
  };
})();

/* ============================================================
   RATY 0% PRZELEWY24 — linijka pod widżetem.
   Widżet P24 pokazuje najniższą ratę ze wszystkich ofert („Kup od…"),
   a jego okno kalkulatora pomija ofertę 0%, choć serwer P24 ją zwraca.
   Pytamy ten sam symulator P24 (te same dane punktu sprzedaży, co
   widżet) i jeśli jest oferta bez kosztów (RRSO 0%, koszt 0 zł),
   dopisujemy: „lub 5 rat 0% po 237,80 zł/mies. (RRSO 0%)".
   Kwota nadąża za zmianą wariantu. Brak oferty = brak linijki.
   ============================================================ */
(function () {
  if (window.INOBA_BEZ_RAT) return; /* raty tylko przy cenach w złotówkach */
  var blok = document.querySelector('.product__info .shopify-app-block[id*="p24"]');
  if (!blok) return;

  var konfig = null;
  for (var i = 0; i < document.scripts.length; i++) {
    var t = document.scripts[i].textContent || '';
    if (t.indexOf('InstallmentCalculatorApp') === -1 || t.indexOf('posid') === -1) continue;
    var sign = t.match(/sign:\s*'([^']+)'/), posid = t.match(/posid:\s*'([^']+)'/),
        method = t.match(/method:\s*'([^']+)'/), amount = t.match(/amount:\s*(\d+)/),
        test = t.match(/test:\s*(true|false)/);
    if (sign && posid && method) {
      konfig = { sign: sign[1], posid: posid[1], method: method[1], amount: amount ? +amount[1] : 0, test: test ? test[1] : 'false' };
    }
    break;
  }
  if (!konfig) return;

  var pamiec = {};
  var ostatnia = 0;

  function ofertaZero(kwota) {
    if (pamiec[kwota]) return pamiec[kwota];
    var url = 'https://apm.przelewy24.pl/sfinks/simulator?' + new URLSearchParams({
      sign: konfig.sign, posid: konfig.posid, method: konfig.method, amount: String(kwota),
      currency: 'PLN', lang: 'pl', test: konfig.test, cms: 'shopify'
    }).toString();
    pamiec[kwota] = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var najlepsza = null;
      ((j && j.data && j.data.installments) || []).forEach(function (plan) {
        (plan.providers || []).forEach(function (p) {
          if (p.rrso === 0 && p.cost === 0 && (!najlepsza || plan.installmentNumber > najlepsza.liczba)) {
            najlepsza = { liczba: plan.installmentNumber, rata: p.installment, suma: p.sum, rrso: p.rrso };
          }
        });
      });
      return najlepsza;
    }).catch(function () { return null; });
    return pamiec[kwota];
  }

  function linijka() {
    var el = blok.querySelector('.inoba-raty-zero');
    if (!el) {
      el = document.createElement('p');
      el.className = 'inoba-raty-zero';
      blok.appendChild(el);
    }
    return el;
  }

  function pokaz(kwota) {
    if (!kwota) return;
    ostatnia = kwota;
    ofertaZero(kwota).then(function (o) {
      if (kwota !== ostatnia) return;
      var el = linijka();
      if (!o) { el.hidden = true; return; }
      /* Rata zawsze z groszami — format cen sklepu zaokrągla do złotych. */
      var kwotaRaty = (o.rata / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' zł';
      var zl = function (gr) { return (gr / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
      /* RRSO z P24 jest w setnych częściach procenta (2853 = 28,53%). */
      var rrso = ((o.rrso || 0) / 100).toFixed(2).replace('.', ',');
      el.innerHTML = 'lub <strong>' + o.liczba + ' rat 0%</strong> po ' + kwotaRaty + '/mies.' +
        '<span class="inoba-raty-zero__przyklad">' + o.liczba + ' rat, Kwota do spłaty: <b>' + zl(o.suma) + ' PLN</b>, RRSO: <b>' + rrso + '%</b>. ' +
        '<a href="https://www.przelewy24.pl/storage/app/media/dokumenty/paypro_przyklady_reprezentatywne_dotyczace_roznych_wariantow_produktu.pdf" target="_blank" rel="noopener noreferrer">Przykład reprezentatywny kredytu</a></span>';
      el.hidden = false;
      wyrownaj();
    });
  }

  /* Tekst zaczyna się tam, gdzie pastylka widżetu (na komputerze obok
     etykiety „Raty:", na telefonie pod nią). */
  function wyrownaj() {
    var el = blok.querySelector('.inoba-raty-zero');
    var w = blok.querySelector('#installment-widget');
    if (!el || !w) return;
    el.style.paddingInlineStart = '0px';
    var przesuniecie = w.getBoundingClientRect().left - el.getBoundingClientRect().left;
    el.style.paddingInlineStart = Math.max(0, Math.round(przesuniecie)) + 'px';
  }
  window.addEventListener('resize', wyrownaj);

  pokaz(konfig.amount);
  document.addEventListener('variant:change', function (ev) {
    var w = ev.detail && ev.detail.variant;
    if (w && typeof w.price === 'number' && w.price > 0) pokaz(w.price);
  }, true);
})();

/* ============================================================
   SHOP THE LOOK — stuknięcie w kropkę na telefonie i tablecie.
   Kropki są linkami do produktu, a motyw wybiera produkt tylko po
   najechaniu kursorem. Na ekranach dotykowych stuknięcie kropki
   pokazuje produkt w podglądzie pod zdjęciem (karuzela), a do karty
   produktu prowadzi dopiero przycisk „Zobacz". Komputer bez zmian.
   ============================================================ */
(function () {
  var dotyk = window.matchMedia('(hover: none), (max-width: 1023px)');
  document.addEventListener('click', function (ev) {
    if (!dotyk.matches) return;
    var kropka = ev.target.closest && ev.target.closest('shop-the-look lookbook-element .hotspot');
    if (!kropka) return;
    var lookbook = kropka.closest('lookbook-element');
    var kropki = Array.prototype.slice.call(lookbook.querySelectorAll('.hotspot'));
    var indeks = kropki.indexOf(kropka);
    if (indeks < 0) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof lookbook.select === 'function') {
      lookbook.select(indeks);
    } else {
      kropki.forEach(function (k, i) { k.setAttribute('aria-current', i === indeks ? 'true' : 'false'); });
      lookbook.dispatchEvent(new CustomEvent('lookbook:change', { bubbles: true, detail: { index: indeks } }));
    }
    /* Podgląd pod zdjęciem ma być w polu widzenia. */
    var karuzela = kropka.closest('shop-the-look').querySelector('carousel-element');
    if (karuzela) {
      var r = karuzela.getBoundingClientRect();
      if (r.bottom > window.innerHeight || r.top < 0) karuzela.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, true);
})();

/* INOBA: „Dobierz do zestawu" – ilość przy pozycji zestawu (snippets/inoba-zestaw-pozycja.liquid).
   theme.js bierze ilość z data-min pola wyboru (koszyk i suma w przycisku), więc tu ją ustawiamy. */
(function () {
  function pozycja(el) { return el.closest('.product-bundle__info'); }
  function ustaw(wiersz, zaznacz) {
    var pole = wiersz.querySelector('input[name="bundles"]');
    var ilosc = wiersz.querySelector('[data-inoba-zestaw-ilosc] input');
    if (!pole || !ilosc) return;
    var min = parseInt(ilosc.min, 10) || 1;
    var n = Math.max(min, parseInt(ilosc.value, 10) || min);
    ilosc.value = n;
    pole.setAttribute('data-min', n);
    if (zaznacz && !pole.disabled) pole.checked = true;
    pole.dispatchEvent(new Event('change', { bubbles: true }));
  }
  document.addEventListener('click', function (e) {
    var przycisk = e.target.closest('[data-inoba-krok]');
    if (!przycisk || !pozycja(przycisk)) return;
    e.preventDefault();
    var ilosc = przycisk.parentElement.querySelector('input');
    ilosc.value = (parseInt(ilosc.value, 10) || 1) + parseInt(przycisk.getAttribute('data-inoba-krok'), 10);
    ustaw(pozycja(przycisk), przycisk.getAttribute('data-inoba-krok') === '1');
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    var wiersz = pozycja(t);
    if (!wiersz) return;
    /* wpisana ilość, albo zmiana wariantu (theme.js przywraca wtedy data-min = minimum wariantu) */
    if (t.closest('[data-inoba-zestaw-ilosc]')) ustaw(wiersz, true);
    else if (t.tagName === 'SELECT') {
      /* theme.js odświeża tylko pierwszą cenę w pozycji – przepisz ją do drugiej (telefon/komputer) */
      var ceny = wiersz.querySelectorAll('.price__regular');
      for (var i = 1; i < ceny.length; i++) ceny[i].innerHTML = ceny[0].innerHTML;
      ustaw(wiersz, false);
    }
  });
})();

/* INOBA: opis kolekcji pod produktami – „Pokaż więcej / mniej” (sections/inoba-opis-kolekcji.liquid). */
(function () {
  function przygotuj() {
    document.querySelectorAll('[data-inoba-opis-zwijany]').forEach(function (opis) {
      var przycisk = opis.parentElement.querySelector('[data-inoba-opis-przycisk]');
      if (!przycisk || opis.dataset.gotowe) return;
      opis.dataset.gotowe = '1';
      if (opis.scrollHeight <= opis.clientHeight + 2) { opis.classList.remove('is-zwiniety'); return; }
      opis.classList.add('ma-wiecej');
      przycisk.hidden = false;
      przycisk.addEventListener('click', function () {
        var zwiniety = opis.classList.toggle('is-zwiniety');
        przycisk.textContent = zwiniety ? przycisk.dataset.wiecej : przycisk.dataset.mniej;
        przycisk.setAttribute('aria-expanded', String(!zwiniety));
        if (zwiniety) opis.scrollIntoView({ block: 'nearest' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', przygotuj); else przygotuj();
  document.addEventListener('shopify:section:load', przygotuj);
})();
